function sbinit(){
  $(".slider-component-desktop").each(function(){
        let ul = $(this).find("ul");
        let scrollbar = $(this).find(".scrollbar");
        let scrollbarDrag = $(this).find(".scrollbar-drag");
        let margin_left = ul.children().first().css("marginLeft");
        scrollbar.css("marginLeft", margin_left);
        scrollbar.css("marginRight", margin_left);
        let width = ul.width();
        let scrollwidth = ul.get(0).scrollWidth;
        let sb_width = scrollbar.width();
        let dragWidth = (width/scrollwidth)*sb_width;
        scrollbarDrag.width(dragWidth);
        ul.scroll(function() {
          let left = ul.scrollLeft();
          let dragPosition = (left/scrollwidth)*sb_width;
          scrollbarDrag.css("left", dragPosition);
        });
  });
}

sbinit();

$(window).on('resize', function(){
    sbinit();
})

